<form [formGroup]="frm" (ngSubmit)="onSubmit(frm)">
  <div class="p-fluid p-formgrid grid compact-form" style="padding: 0.5rem!important;">
    <div class="p-field col-12 md:col-6 compact-form">
      <label for="iacmacNumber">Номер МАКМАХ</label>
        <input pInputText style="width: 100%" id="iacmacNumber" type="text" formControlName="iacmacNumber">
        <p-message severity="error" *ngIf="frm.controls['iacmacNumber'].hasError('required')" text="Обязательное поле">
        </p-message>
    </div>
    <div class="p-field col-12 md:col-6 compact-form">
      <label for="iacmacDate">Дата регистрации</label>
      <p-calendar formControlName="iacmacDate" styleClass="calendar-compact" [showIcon]="true" [showOnFocus]="false"
        dateFormat="dd-mm-yy" [showTime]="true" hourFormat="24" dataType="string" inputId="iacmacDate"></p-calendar>
        <p-message severity="error" *ngIf="frm.controls['iacmacDate'].hasError('required')" text="Обязательное поле">
        </p-message>
    </div>
  </div>
  <!-- <pre>{{ frm.value | json }}</pre> -->
  <hr>
  <p-footer>
    <button pButton class="p-button-success" icon="pi pi-check" label="Сохранить" type="submit"
    [disabled]="!frm.valid"></button>
<button pButton type="button" icon="pi pi-ban" class="p-button-secondary" label="Закрыть"
    (click)="onCancel()"></button>
  </p-footer>
</form>
